import pluralize from '@sravni/utils/lib/pluralize';

export const getDaysPluralize = (value: number) => pluralize(value, 'день', 'дня', 'дней') ?? 'день';
